{
  "Accessibility Menu": "Мени За Приступачност",
  "Reset settings": "Ресетуј поставке",
  "Close": "Затвори",
  "Content Adjustments": "Подешавање Садржаја",
  "Adjust Font Size": "Подешавање Величине Фонта",
  "Highlight Title": "Означи Наслове",
  "Highlight Links": "Означи Везе",
  "Readable Font": "Читљивији Фонт",
  "Color Adjustments": "Подешавање Боја",
  "Dark Contrast": "Тамни Контраст",
  "Light Contrast": "Свијетли Контраст",
  "High Contrast": "Високи Контраст",
  "High Saturation": "Велика Засићеност",
  "Low Saturation": "Ниска Засићеност",
  "Monochrome": "Једнобојни",
  "Contrast": "Контраст",
  "Invert Colors": "Инверзија боја",
  "Tools": "Алати",
  "Reading Guide": "Водич За Читање",
  "Stop Animations": "Заустави Анимације",
  "Big Cursor": "Велики Курсор",
  "Increase Font Size": "Повећај Величину Фонта",
  "Decrease Font Size": "Смањи Величину Фонта",
  "Letter Spacing": "Размак Слова",
  "Line Height": "Висина Линије",
  "Font Weight": "Дебљина Фонта",
  "Dyslexia Font": "Фонт За Дислексичаре",
  "Language": "Језик",
  "Open Accessibility Menu": "Отвори Мени За Приступачност",
  "Widget Settings": "Подешавања виџета",
  "Widget Position": "Позиција виџета",
  "Top Left": "Горе лево",
  "Top Center": "Горе у центру",
  "Top Right": "Горе десно",
  "Center Left": "Центар лево",
  "Center Right": "Центар десно",
  "Bottom Left": "Доле лево",
  "Bottom Center": "Доле у центру",
  "Bottom Right": "Доле десно",
  "Screen Reader": "Читач екрана",
  "Voice Navigation": "Гласовна навигација",
  "Custom Color": "Прилагођена боја",
  "Change the site's colors": "Промени боје сајта",
  "Backgrounds": "Позадине",
  "Headings": "Наслови",
  "Contents": "Садржај",
  "Reset colors": "Ресетуј боје",
  "Image Desaturation": "Десатурација слике",
  "Search languages": "Претражи језике",
  "No languages found": "Ниједан језик није пронађен",
  "Accessibility Profiles": "Профили приступачности",
  "Motor Impaired": "Покретна ограничења",
  "Big cursor, voice navigation, and no animations.": "Велики курсор, гласовна навигација и без анимација.",
  "Blind": "Слепи",
  "Screen reader helpers with higher contrast.": "Помагачи читача екрана са већим контрастом.",
  "Color Blind": "Далтонзам",
  "High contrast palette with desaturated media.": "Палета високог контраста са умањеним бојама.",
  "Dyslexia": "Дислексија",
  "Friendly font, extra spacing, stronger weight.": "Лако читљив фонт, више размака и израженије слово.",
  "Low vision": "Слабовидост",
  "Dark contrast and 130% magnification.": "Таман контраст и 130% увећање.",
  "Cognitive & Learning": "Когнитивно и учење",
  "Highlights key sections and enables voice help.": "Истиче кључне целине и омогућава гласовну помоћ.",
  "Seizure & Epileptic": "Напади и епилепсија",
  "Stops animations and desaturates imagery.": "Зауставља анимације и умањује засићење слика.",
  "ADHD": "АДХД",
  "Reading guide, highlighted links, calmer palette.": "Водич за читање, наглашене везе и смиренија палета.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
